import { Chapter, FadeIn } from "./Reveal";
import { IMAGES } from "../data/site";

export const About = () => (
    <section
        id="about"
        data-testid="about-section"
        className="relative overflow-hidden py-28 md:py-40"
    >
        <div className="pointer-events-none absolute -right-24 top-1/2 hidden -translate-y-1/2 opacity-[0.08] lg:block">
            <img src={IMAGES.pipes} alt="" className="h-[540px] w-[420px] object-cover" />
        </div>
        <div className="relative mx-auto max-w-screen-2xl px-6 md:px-12">
            <Chapter number="01" label="About" />
            <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
                <FadeIn className="lg:col-span-8">
                    <h2 className="font-grotesk text-3xl font-medium leading-[1.08] tracking-tight text-zinc-100 md:text-5xl lg:text-6xl">
                        We turn <span className="text-ember">molten metal</span> into
                        motion — forging, casting and machining the components that keep
                        the world&apos;s vehicles moving.
                    </h2>
                </FadeIn>
                <FadeIn delay={0.15} className="flex flex-col justify-end gap-6 lg:col-span-4">
                    <p className="text-sm leading-relaxed text-zinc-400 md:text-base">
                        Since 2014, SVS Balaji Industries has cast, forged and machined
                        critical automotive components for reputed OEMs and Tier-1
                        suppliers — across India and export markets worldwide.
                    </p>
                    <p className="text-sm leading-relaxed text-zinc-500 md:text-base">
                        From billet to boxed component, every stage runs under one roof —
                        so tolerances hold, batches trace, and deliveries land on time.
                    </p>
                    <div className="flex items-center gap-4 border-t border-line pt-6">
                        <span className="font-display text-4xl text-ember md:text-5xl">12</span>
                        <span className="font-mono text-[10px] uppercase leading-relaxed tracking-[0.2em] text-zinc-500 md:text-xs">
                            Years of forging
                            <br />
                            heritage
                        </span>
                    </div>
                </FadeIn>
            </div>
        </div>
    </section>
);
